$.fn.unwrapper = function(id) {
    var ea="";
    $(id+" [role=presentation]").each(function( index, element){
        if($(this).hasClass('dropdown')){

        }else if($(this).hasClass('active')) {
            ea += '<li role="presentation" class="active">' + $(this).html() + '</li>';
        }else{
            ea += '<li role="presentation">' + $(this).html() + '</li>';
        }

    })
    $(id).empty();
    $(id).html(ea);
};

$.fn.responsivetab = function(param) {
    var id= this.selector;
    var text = param.text;
    $.fn.unwrapper(id);
    var totalwidth=$(id).width();
    var count = $(id).children().length;
    var width = 0;

    for (var i = 0; i <= count; i++) {
        width += $(""+id+" li:nth-child("+i+")").outerWidth();

        if(i < count) {
            if(width + 105 >totalwidth){ // 105 is rough estimate of the width of the More button when it becomes a dropdown toggle
                $(""+id+" li").slice(i-1,count).wrapAll('<li role="presentation" class="dropdown"><ul class="dropdown-menu" aria-labelledby="detailTab" id="detailTabContent"></ul></li>');
                $(""+id+" .dropdown").prepend('<a href="#" class="nav-link" data-toggle="dropdown" aria-controls="detailTabContent" aria-expanded="true">'+text+'</a>');
                return;
            }
        } else if(width>totalwidth) {
            $(""+id+" li").slice(i-1,count).wrapAll('<li role="presentation" class="dropdown"><ul class="dropdown-menu" aria-labelledby="detailTab" id="detailTabContent"></ul></li>');
            $(""+id+" .dropdown").prepend('<a href="#" class="nav-link" data-toggle="dropdown" aria-controls="detailTabContent" aria-expanded="true">'+text+'</a>');
            return;
        }
    }
};

$(window).load(function() {
    $('#blog-category-nav-list').responsivetab({
        text: 'More',
    });
});

$(window).on('resize', function() {
    $('#blog-category-nav-list').responsivetab({
        text: 'More',
    });
});